module.exports = __webpack_public_path__ + "static/media/O-yellow.3ef86713.svg";